import { createFileRoute } from '@tanstack/react-router';
import { EnterpriseEnrollLanding } from 'src/components/EnterpriseEnrollLanding';

export const Route = createFileRoute('/_public/connect-for-business')({
  component: () => <EnterpriseEnrollLanding />,
});
